import { create } from 'zustand';
import qs from 'qs';
import { devtools } from 'zustand/middleware';

import api from 'core/api';
import {
  CANCEL_NEW_PROPOSALS_URL,
  CANCEL_PROPOSALS_URL,
} from 'utils/api';

const useProposalCenterStore = create()(devtools(
  (get, set) => ({
    data: [],
    newOperationsCancel: {
      cancelationId: null,
      loading: false,
      success: true,
      error: false,
    },
    addData: (id) => {
      set(state => ({
        data: [...state.data, id],
      }));
    },
    getProposalsReport: ({ Filters }) => api.get(`/unwinding/proposals/report?${qs.stringify(
      { Filters: Filters },
      { arrayFormat: 'repeat', allowDots: true },
    )}`, { responseType: 'arraybuffer' }),
    getCancelNewOperationsProposal: proposalId => api.post(CANCEL_NEW_PROPOSALS_URL.replace('{codigoOrdem}', proposalId)),
    getCancelProposal: proposalId => api.patch(CANCEL_PROPOSALS_URL, { orderId: proposalId }),
  }),
));

export default useProposalCenterStore;
